import { memo } from 'react'

import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { Header } from '@shared/components/Header'
import { Tabs } from '@shared/components/MaterialUIEnhancements/Tabs'
import { Content } from '@shared/layouts'
import { NavigationTabLink } from 'components/LinkedMUIComponents/NavigationTabLink'
import { ActionsMenu } from 'domains/Workspaces/Video/Objects/Object/Blobs/Blob/ActionsMenu'
import {
  videoObjectBlobConfigRoute,
  videoObjectBlobRoute,
  videoObjectBlobWatchRoute,
} from 'pages/NWPlatform/Workspaces/Workspace/Video/Objects/Object/Blobs/Blob/Routing'
import { videoObjectQueryKeys } from 'services/queryKeys'

const StructureRaw = () => {
  const { t } = useTranslation(['common', 'pages', 'entity'])

  const { videoobjectId: videoId, blobId } = videoObjectBlobRoute.useParams()

  const videoObjectBlobQuery = useQuery(videoObjectQueryKeys.blobDetail({ blobId, videoId }))

  return (
    <Content
      HeaderSlot={
        <Header
          disabled
          title={videoObjectBlobQuery.data?.storeId ?? t('noNameSet')}
          Actions={<ActionsMenu />}
          TabNavigation={
            <Tabs>
              <NavigationTabLink from={videoObjectBlobRoute.to} to={videoObjectBlobWatchRoute.to}>
                {t('pages:Workspace.watch')}
              </NavigationTabLink>
              <NavigationTabLink from={videoObjectBlobRoute.to} to={videoObjectBlobConfigRoute.to}>
                {t('pages:Workspace.config')}
              </NavigationTabLink>
            </Tabs>
          }
        />
      }
    />
  )
}

export const Structure = memo(StructureRaw)
